import React from 'react';
import { connect } from 'react-redux';
import { getShowConvertedGifs } from '../../refresh/selectors/featureFlagsSelector';
/*
  @author: Mayur Ray
  @description: Gif images will convert to video on the basis of contentType and showConvertedGifs flag
*/
const mapStateToProps = state => {
  return {
    showConvertedGifs: getShowConvertedGifs(state) === 'ON'
  };
};

const GifToVideo = ({ showConvertedGifs = false, ariaHiddenImg=false, alt='', loading='', ...props }) => {
  const [contentType, setContentType] = React.useState('');
  const [loader, setLoader] = React.useState(true);

  React.useEffect(() => {
    if (showConvertedGifs && props.src && props.src.includes('gif') && props.src.includes('assets-jiocdn.ajio.com')) { // code not used
      // Calling to fetch content-type of the asset
      const fetchContentType = async url => {
        try {
          const response = await fetch(`${url}?convertGif=true`, {
            method: 'HEAD'
          });
          setContentType(response.headers.get('Content-Type'));
        } catch (e) {
          console.error('Serving original assets because of', e);
        }
        setLoader(false);
      };
      fetchContentType(props.src);
    } else {
      setLoader(false);
    }
  }, [props.src]);

  return (
    <>
      {!loader &&
        (showConvertedGifs && contentType?.includes('video')) ? (
          <video {...props} src={`${props.src}?convertGif=true`} loop muted autoPlay playsInline/>
        ) : (
            <img {...props} aria-hidden={ariaHiddenImg} alt={alt} loading={loading} className={props.className} />
      )}
    </>
  );
};

export default connect(mapStateToProps)(GifToVideo);
